import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFillIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m12 3 8 5.5v7L12 21l-8-5.5v-7z",
		opacity: .15
	}), /* @__PURE__ */ _jsx("path", { d: "m12 3 8 5.5v7L12 21l-8-5.5v-7z" })]
});
export default SvgFillIcon;
